import { db } from '../config/firebase';

const collection = 'products';

async function retrieveAll() {
  let query = db.collection(collection);

  query = query.orderBy('order', 'asc');

  const querySnapshot = await query.get();

  let results = [];
  querySnapshot.forEach(doc => {
    results.push({
      id: doc.id,
      ...doc.data()
    });
  });

  return results;
}

async function retrieveActive(isHighlight) {
  let query = db.collection(collection);

  query = query.where("isActive", "==", true)
    .where("isHighlight", "==", isHighlight)
    .orderBy('order', 'asc');

  const querySnapshot = await query.get();

  let results = [];
  querySnapshot.forEach(doc => {
    results.push({
      id: doc.id,
      ...doc.data()
    });
  });

  return results;
}

export default {
  retrieveAll,
  retrieveActive
}